import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Col, Nav, NavItem, NavLink, Row, TabContent, TabPane,
} from 'reactstrap';

function HorizontalTabs({ headers, children }) {
  const [activeTab, setActiveTab] = useState(0);
  return (
    <>
      <Nav className="border-tab" tabs>
        {headers.map((header, index) => (
          <NavItem key={header.content}>
            <NavLink href="#" className={activeTab === index ? 'active' : ''} onClick={() => setActiveTab(index)}>{header.content}</NavLink>
          </NavItem>
        ))}
      </Nav>
      <TabContent activeTab={activeTab}>
        {children && children.map((child, index) => <TabPane key={`tab-content-${index}`} className="fade show" tabId={index}>{child}</TabPane>)}
      </TabContent>
    </>
  );
}

HorizontalTabs.propTypes = {
  headers: PropTypes.array.isRequired,
};

export default HorizontalTabs;
